import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "选择游玩角色", -1)
const _hoisted_3 = { class: "emblems" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"role titan\"><div class=\"description\"><p class=\"name\">泰坦</p><p class=\"sub\">人类 / 觉醒者 / Exo</p></div><div class=\"light\">1600</div></div>", 1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"role hunter\"><div class=\"description\"><p class=\"name\">猎人</p><p class=\"sub\">人类 / 觉醒者 / Exo</p></div><div class=\"light\">1600</div></div>", 1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"role warlock\"><div class=\"description\"><p class=\"name\">术士</p><p class=\"sub\">人类 / 觉醒者 / Exo</p></div><div class=\"light\">1600</div></div>", 1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"role corrupted\"><div class=\"description\"><p class=\"name\">火力战队队长</p><p class=\"sub\">人类 / 觉醒者 / Exo</p></div><div class=\"light\">9999</div></div>", 1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "list" }
const _hoisted_13 = { class: "link" }
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h1", {
  class: "title game-title",
  style: {"color":"#8AB2FF"}
}, "游戏开始前请阅读以下信息", -1)
const _hoisted_16 = { class: "box game-box" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "text game-config" }, "请确认已完整的阅读游戏说明和游戏玩法后进行游戏", -1)
const _hoisted_18 = { class: "links" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "text game-save" }, [
  /*#__PURE__*/_createTextVNode("如果你之前有玩过此游戏，请先点击选择角色下方的 "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#FF4DFF"} }, "清除数据按钮"),
  /*#__PURE__*/_createTextVNode(" 后再创建角色")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "text game-web" }, [
  /*#__PURE__*/_createTextVNode("请使用 "),
  /*#__PURE__*/_createElementVNode("span", { class: "edge" }, "MicroSoft Edge 浏览器"),
  /*#__PURE__*/_createTextVNode(" 或使用 "),
  /*#__PURE__*/_createElementVNode("span", { class: "chrome" }, "Google Chrome 浏览器"),
  /*#__PURE__*/_createTextVNode(" 进行游玩 ")
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "text game-time" }, "请确保游玩时间充足，游玩时间约 2-3 小时", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h1", { class: "title role-title" }, "设置游戏角色信息", -1)
const _hoisted_23 = { class: "box role-id-box" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", { class: "title role-id-title" }, "选择游戏编号", -1)
const _hoisted_25 = { class: "name-box role-name-box" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "role-name-title" }, "输入你的游戏名称 / 游戏ID", -1)
const _hoisted_27 = { class: "role-confirm-box" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("h1", { class: "title captain-title" }, "设置游戏角色信息", -1)
const _hoisted_29 = { class: "box captain-position-box" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "title captain-position-title" }, "选择游玩职业", -1)
const _hoisted_31 = { class: "name-box captain-name-box" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", { class: "captain-name-title" }, "输入你的游戏名称 / 游戏ID", -1)
const _hoisted_33 = { class: "captain-confirm-box" }
const _hoisted_34 = { class: "footer" }

import {deleteSave, read} from "@/assets/ts/utils";
import {
  gameDialogVisible,
  roleDialogVisible,
  captainDialogVisible,
  roleModel,
  roleIdModel,
  roleNameModel,
  setRole,
  setRoleId,
  setRoleInfo,
  initHome
} from "@/assets/ts/home"

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

initHome();
const gameConfig = read();
const version = gameConfig.version;

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          class: "emblem",
          id: "titan",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(setRole)('player', 'titan')))
        }, _hoisted_5),
        _createElementVNode("a", {
          class: "emblem",
          id: "hunter",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(setRole)('player', 'hunter')))
        }, _hoisted_7),
        _createElementVNode("a", {
          class: "emblem",
          id: "warlock",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(setRole)('player', 'warlock')))
        }, _hoisted_9),
        _createElementVNode("a", {
          class: "emblem",
          id: "captain",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(setRole)('captain', '')))
        }, _hoisted_11),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_router_link, { to: "destiny2" }, {
              default: _withCtx(() => [
                _createTextVNode("游戏说明")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "gameplay" }, {
              default: _withCtx(() => [
                _createTextVNode("游戏玩法")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "update" }, {
              default: _withCtx(() => [
                _createTextVNode("更新日志")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "copyright" }, {
              default: _withCtx(() => [
                _createTextVNode("版权声明")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("button", {
            class: "button",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(deleteSave)()))
          }, "一键清除游戏数据")
        ])
      ]),
      _createVNode(_component_el_dialog, {
        class: "dialog game-dialog",
        modelValue: _unref(gameDialogVisible),
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(gameDialogVisible) ? (gameDialogVisible).value = $event : null)),
        "close-on-click-modal": false,
        "align-center": ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            class: "game-logo",
            src: require('@/assets/images/Raid.png'),
            alt: "Logo"
          }, null, 8, _hoisted_14),
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_router_link, {
                class: "link",
                to: "destiny2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("→ 游戏说明 ←")
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                class: "link",
                to: "gameplay"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("→ 游戏玩法 ←")
                ]),
                _: 1
              })
            ]),
            _hoisted_19,
            _hoisted_20,
            _hoisted_21
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "button game-confirm",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (gameDialogVisible.value = false))
          }, "确认")
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        class: "dialog role-dialog",
        modelValue: _unref(roleDialogVisible),
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_isRef(roleDialogVisible) ? (roleDialogVisible).value = $event : null)),
        "close-on-click-modal": false,
        "align-center": ""
      }, {
        default: _withCtx(() => [
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createVNode(_component_el_radio_group, {
              modelValue: _unref(roleIdModel),
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(roleIdModel) ? (roleIdModel).value = $event : null))
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
                  return _createVNode(_component_el_radio, {
                    key: index,
                    label: index,
                    onChange: ($event: any) => (_unref(setRoleId)('' + (index + 1)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString((index + 1)) + " 号 ", 1)
                    ]),
                    _: 2
                  }, 1032, ["label", "onChange"])
                }), 64))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createVNode(_component_el_input, {
              modelValue: _unref(roleNameModel),
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(roleNameModel) ? (roleNameModel).value = $event : null)),
              placeholder: "请输入你的游戏名称 / 游戏ID"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("button", {
              type: "button",
              class: "button role-confirm",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(setRoleInfo)('player')))
            }, "确认 "),
            _createElementVNode("button", {
              type: "button",
              class: "button role-cancel",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (roleDialogVisible.value = false))
            }, "取消")
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        class: "dialog captain-dialog",
        modelValue: _unref(captainDialogVisible),
        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_isRef(captainDialogVisible) ? (captainDialogVisible).value = $event : null)),
        "close-on-click-modal": false,
        "align-center": ""
      }, {
        default: _withCtx(() => [
          _hoisted_28,
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createVNode(_component_el_radio_group, {
              modelValue: _unref(roleModel),
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_isRef(roleModel) ? (roleModel).value = $event : null))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  label: 1,
                  onChange: _cache[12] || (_cache[12] = ($event: any) => (_unref(setRole)('captain','titan')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("泰坦")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: 2,
                  onChange: _cache[13] || (_cache[13] = ($event: any) => (_unref(setRole)('captain','hunter')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("猎人")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: 4,
                  onChange: _cache[14] || (_cache[14] = ($event: any) => (_unref(setRole)('captain','warlock')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("术士")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _createVNode(_component_el_input, {
              modelValue: _unref(roleNameModel),
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_isRef(roleNameModel) ? (roleNameModel).value = $event : null)),
              placeholder: "请输入你的游戏名称 / 游戏ID"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("button", {
              type: "button",
              class: "button captain-confirm",
              onClick: _cache[17] || (_cache[17] = ($event: any) => (_unref(setRoleInfo)('captain')))
            }, "确认 "),
            _createElementVNode("button", {
              type: "button",
              class: "button captain-cancel",
              onClick: _cache[18] || (_cache[18] = ($event: any) => (captainDialogVisible.value = false))
            }, "取消")
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("p", null, "当前网页版本为 RogueLike Raid Version " + _toDisplayString(_unref(version)) + " | 请完整的阅读 《游戏说明》 与 《游戏玩法》 后再开始游戏，以免影响游戏体验", 1)
    ])
  ], 64))
}
}

})